function isLocalStorageAvailable() {
    try {
        return 'localStorage' in window && window['localStorage'] !== null;
    } catch (e) {
        return false;
    }
}

function MemoryStorage() {
    var storage = new Map()
    console.warn('Browser localstorage is not available. Using in-memory storage')

    this.setItem = function (key, value) {
        storage.set(key, value);
    }

    this.getItem = function (key) {
        return storage.get(key);
    }

    this.removeItem = function (key) {
        storage.delete(key);
    }

    this.clear = function () {
        storage.clear()
    }

    this.key = function (index) {
        return Array.from(storage.values())[index]
    }
}

services.service('LocalStorage', function () {
    var self = this,
        ls = isLocalStorageAvailable() ? window['localStorage'] : new MemoryStorage(),
        prefix = 'panda-forex__';

    this.save = function (key, value) {
        ls.setItem(prefix + key, value);
    };

    this.set = this.save;

    this.get = function (key) {
        return ls.getItem(prefix + key);
    };

    this.remove = function (key) {
        ls.removeItem(prefix + key);
    };

    this.clear = function () {
        Object.keys(ls).forEach(function (item) {
            if (item.match(new RegExp('^' + prefix))) {
                self.remove(item);
            }
        });
    };

    return this;
});
